import {Head, Link} from '@inertiajs/react'
import Form from './form.tsx'
import type { CategoryType, CommunityOptionType, TaxModuleOptionType, TaxModulesByCommunityType } from './types.ts'
import {ArrowLeft} from "lucide-react";

interface EditProps {
  category: CategoryType
  tax_modules: TaxModuleOptionType[]
  communities?: CommunityOptionType[]
  can_select_community?: boolean
  tax_modules_by_community?: TaxModulesByCommunityType
}

export default function Edit({
  category,
  tax_modules,
  communities = [],
  can_select_community = false,
  tax_modules_by_community,
}: EditProps) {
  return (
    <>
      <Head title="Editing category" />

      <div className="flex flex-col gap-6 p-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link href={`/admin/categories/${category.id}`}>
              <button className="rounded-lg border border-border p-2 text-foreground hover:bg-secondary transition-colors">
                <ArrowLeft className="h-5 w-5" />
              </button>
            </Link>
            <div>
              <h1 className="text-3xl font-bold text-foreground">Editer la categorie</h1>
            </div>
          </div>
        </div>

        <Form
          category={category}
          tax_modules={tax_modules}
          communities={communities}
          can_select_community={can_select_community}
          tax_modules_by_community={tax_modules_by_community}
          action={`/admin/categories/${category.id}`}
          method="patch"
          submitText="Mettre à jour la catégorie"
        />

      </div>
    </>
  )
}
